import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=0068aa20&scoped=true&"
import script from "./Error404.vue?vue&type=script&lang=ts&"
export * from "./Error404.vue?vue&type=script&lang=ts&"
import style0 from "./Error404.vue?vue&type=style&index=0&id=0068aa20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0068aa20",
  null
  
)

export default component.exports